import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import * as _ from 'lodash';
import AddressService from '../../services/address';
import messageDialog from '../../components/message-dialog.vue'
import MapLoader from 'google-maps';
import Axios from 'axios';

const CLASS_PIN_REGULAR = "pin";
const CLASS_PIN_SELECTED = "pin-selected";


//// funções para criar um pin customizado
//// todo: refatorar para permitir reutilização

const counterPinCache = new Map();
// Necessário especificar o prefixo "!!raw-loader!" para o webpack forçar carregar
// o arquivo como string.
const counterPinTemplate = require('!!raw-loader!../../assets/markers/pin.svg');

function createCounterPin(val, clazz) {
  let key = JSON.stringify(arguments);

  // verifica cache
  let pin = counterPinCache.get(key);
  if (pin) return pin;

  let pinSvg = $(counterPinTemplate);
  pinSvg.find('#icon').addClass(clazz);

  pinSvg.find('#value')
    .addClass(clazz)
    .text(val);

  let _html = $('<div>').append($(pinSvg).clone()).html();
  pin = "data:image/svg+xml;base64," + btoa(_html);
  counterPinCache.set(key, pin);
  return pin;
}

export default {
  props: ['endereco', 'conveniado'],

  data() {
    return {
      end: {
        inicio: undefined,
        end1: undefined,
        linha1: undefined,
        end2: undefined,
        linha2: undefined,
        end3: undefined,
        linha3: undefined,
      },
      count: 1,
      map: undefined,
      google: undefined,
      geocoder: undefined
    };
  },

  watch: {
    conveniado(){
      if(this.conveniado){
        var point = new L.LatLng(this.conveniado.latitude, this.conveniado.longitude);

          var pointList = [this.end.inicio.getLatLng(), point];
        if(this.count == 1){
          if(this.end.end1){
            this.map.removeLayer(this.end.end1);
            this.map.removeLayer(this.end.linha1);
          }

        let polyline = new L.Polyline(pointList, {
            color: 'blue',
            weight: 4,
            opacity: 0.5,
            smoothFactor: 1
          }).addTo(this.map);

        let size = 50; //Math.max(Math.min(y, 70), 40);
        let marker = L.marker([point.lat,point.lng], {
          icon: L.icon({
            iconUrl: createCounterPin('P2', CLASS_PIN_SELECTED),
            iconSize: [size, size],
            //iconAnchor: [size * 0.5, size],
            //popupAnchor: [size * 0,5, 100]
          })
        }).addTo(this.map);

        if(this.conveniado.domingo){
          let popup = "<b>Dias de funcionamento</b>" +
          "<br>Domingo: " + this.conveniado.domingo +
          "<br>Segunda: " + this.conveniado.segunda +
          "<br>Terca: " + this.conveniado.terca +
          "<br>Quarta: " + this.conveniado.quarta +
          "<br>Quinta: " + this.conveniado.quinta +
          "<br>Sexta: " + this.conveniado.sexta +
          "<br>Sabado: " + this.conveniado.sabado;

          if(this.conveniado.infoAdd){
            popup = popup + "<br><br><b>Informações Adicionais</b><br>" +  this.conveniado.infoAdd;
          }
          marker.bindPopup(popup).openPopup();
        }else {
          marker.bindPopup("<b>Dias de funcionamento</b><br>Não informado.").openPopup();
        }

          this.end.end1 = marker;
          this.end.linha1 = polyline;
          this.count = 2;

          let mapa = {
            marcador: 'P2',
            nomeFantasia: this.conveniado.nomeFantasia,
            numero: this.conveniado.numero
          }
          this.$emit('mapeados',mapa);
        }else if(this.count == 2){
          if(this.end.end2){
            this.map.removeLayer(this.end.end2);
            this.map.removeLayer(this.end.linha2);
          }

          let polyline = new L.Polyline(pointList, {
              color: 'red',
              weight: 4,
              opacity: 0.5,
              smoothFactor: 1
            }).addTo(this.map);

        let size = 50; //Math.max(Math.min(y, 70), 40);
        let marker = L.marker([point.lat,point.lng], {
          icon: L.icon({
            iconUrl: createCounterPin('P3', CLASS_PIN_SELECTED),
            iconSize: [size, size],
            //iconAnchor: [size * 0.5, size],
            //popupAnchor: [size * 0,5, 100]
          })
        }).addTo(this.map);

        if(this.conveniado.domingo){
          let popup = "<b>Dias de funcionamento</b>" +
          "<br>Domingo: " + this.conveniado.domingo +
          "<br>Segunda: " + this.conveniado.segunda +
          "<br>Terca: " + this.conveniado.terca +
          "<br>Quarta: " + this.conveniado.quarta +
          "<br>Quinta: " + this.conveniado.quinta +
          "<br>Sexta: " + this.conveniado.sexta +
          "<br>Sabado: " + this.conveniado.sabado;

          if(this.conveniado.infoAdd){
            popup = popup + "<br><br><b>Informações Adicionais</b><br>" +  this.conveniado.infoAdd;
          }
          marker.bindPopup(popup).openPopup();
        }else {
          marker.bindPopup("<b>Dias de funcionamento</b><br>Não informado.").openPopup();
        }


        this.end.end2 = marker;
        this.end.linha2 = polyline;
        this.count = 3;

        let mapa = {
          marcador: 'P3',
          nomeFantasia: this.conveniado.nomeFantasia,
          numero: this.conveniado.numero
        }
        this.$emit('mapeados',mapa);
      }else if(this.count == 3){
        if(this.end.end3){
            this.map.removeLayer(this.end.end3);
            this.map.removeLayer(this.end.linha3);
          }

          let polyline = new L.Polyline(pointList, {
              color: 'green',
              weight: 4,
              opacity: 0.5,
              smoothFactor: 1
            }).addTo(this.map);

        let size = 50; //Math.max(Math.min(y, 70), 40);
        let marker = L.marker([point.lat,point.lng], {
          icon: L.icon({
            iconUrl: createCounterPin('P4', CLASS_PIN_SELECTED),
            iconSize: [size, size],
            //iconAnchor: [size * 0.5, size],
            //popupAnchor: [size * 0,5, 100]
          })
        }).addTo(this.map);

        if(this.conveniado.domingo){
          let popup = "<b>Dias de funcionamento</b>" +
          "<br>Domingo: " + this.conveniado.domingo +
          "<br>Segunda: " + this.conveniado.segunda +
          "<br>Terca: " + this.conveniado.terca +
          "<br>Quarta: " + this.conveniado.quarta +
          "<br>Quinta: " + this.conveniado.quinta +
          "<br>Sexta: " + this.conveniado.sexta +
          "<br>Sabado: " + this.conveniado.sabado;

          if(this.conveniado.infoAdd){
            popup = popup + "<br><br><b>Informações Adicionais</b><br>" +  this.conveniado.infoAdd;
          }
          marker.bindPopup(popup).openPopup();
        }else {
          marker.bindPopup("<b>Dias de funcionamento</b><br>Não informado.").openPopup();
        }

        this.end.end3 = marker;
        this.end.linha3 = polyline;
        this.count = 1;

        let mapa = {
          marcador: 'P4',
          nomeFantasia: this.conveniado.nomeFantasia,
          numero: this.conveniado.numero
        }
        this.$emit('mapeados',mapa);
        }
      }
    },

    async endereco(){
      if(this.end.inicio)
        this.map.removeLayer(this.end.inicio);
      if(this.end.end1){
        this.map.removeLayer(this.end.end1);
        this.map.removeLayer(this.end.linha1);
      }
      if(this.end.end2){
        this.map.removeLayer(this.end.end2);
        this.map.removeLayer(this.end.linha2);
      }
      if(this.end.end3){
        this.map.removeLayer(this.end.end3);
        this.map.removeLayer(this.end.linha3);
      }

      try {
        if (!this.endereco) return;
        const { data: { logradouro, localidade } } = await Axios.get(`https://viacep.com.br/ws/${this.endereco.replaceAll('-', '')}/json`);
        if(!logradouro || !localidade) throw new Error();
        await this.findAddressByGoogle(`${logradouro},${localidade}`);
      } catch(e) {
        if (!this.endereco) return;
        await this.findAddressByGoogle(this.endereco.replaceAll('-', ''));
      }
    }
  },
  mounted() {
    this.map = L.map(this.$el).setView([-23.533773, -46.625290], 15);
    /*this.map = L.map(this.$el).fitWorld();
    //this.map.locate({setView: true, maxZoom: 16});//Posição atual */
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy;<a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(this.map);

    let vm = this;
    MapLoader.KEY = 'AIzaSyAzAwCX1zCJ9idWkNdxs39j36N4lAToIjE';
    MapLoader.LIBRARIES = ['places'];
    MapLoader.load(function(google) {
      vm.google = google;
      vm.geocoder = new google.maps.Geocoder();
      vm.geocoder.geocode( { 'address': '14801525'}, function(results, status) {
        
        
        
      });
    });

  },
  
  methods: {
    findAddressByGoogle(address) {
      let vm = this;
      vm.geocoder.geocode( { address }, async function(results) {
        try {
          let lat = results[0].geometry.location.lat();
          let lng = results[0].geometry.location.lng();

          var point = new L.LatLng(lat, lng);

          let size = 50;
          let marker = L.marker([point.lat,point.lng], {
            icon: L.icon({
              iconUrl: createCounterPin('P1', CLASS_PIN_REGULAR),
              iconSize: [size, size],
            })
          }).addTo(vm.map);

          vm.end.inicio = marker;
          vm.map.panTo(point);
          vm.$emit('listaProximos',lat,lng);
        } catch (e) {
          messageDialog.show({
            title: 'Aviso',
            message: 'CEP invalido!',
            headerClass: 'modal-info'
          });
        }
      });
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/external/mapa-parceiros.js